module.exports = __webpack_public_path__ + "static/media/fg_th.c762316b.png";